<form #stripeForm="ngForm" id="payment-form">
  <div class="title-heading">{{ title }}</div>
  <div>
    @if (errorMessage) {
      <div>
        <b style="color: maroon">
          {{ errorMessage }}
        </b>
      </div>
    }
    <div class="form-group">
      <label class="control-label oa-input-label">Name on Card</label>
      <input
        id="name-on-card-input"
        type="text"
        [(ngModel)]="card.name"
        [disabled]="disabled"
        class="form-control"
        placeholder="Name on Card"
        autocomplete="cc-name"
        minlength="1"
        maxlength="50"
        size="30"
        name="nameOnCard"
        #nameOnCard="ngModel"
        required
        />
        @if (nameOnCard.invalid && (nameOnCard.dirty || nameOnCard.touched || captureError)) {
          <div class="text-danger">
            @if (nameOnCard.errors.required) {
              <div>Name is required.</div>
            }
          </div>
        }
      </div>
      <!-- <div class="form-group">
      <label class="control-label oa-input-label">Credit Card Number</label>
      <div class="input-group">
        <input
          id="card-number-input"
          type="text"
          [(ngModel)]="inputCardNumber"
          (ngModelChange)="onNumberChange($event)"
          [disabled]="disabled || stripeSource !== undefined"
          class="form-control"
          placeholder="Credit Card Number"
          autocomplete="cc-number"
          minlength="14"
          maxlength="19"
          size="19"
          inputmode="numeric"
          name="cardNumber"
          #cardNumber="ngModel"
          required
          />
          <span class="input-group-addon" id="basic-addon1">
            <i class="fa fa-fw {{ cardType }}"></i>
          </span>
        </div>
        <div *ngIf="cardNumber.invalid && (cardNumber.dirty || cardNumber.touched || captureError)" class="text-danger">
          <div *ngIf="cardNumber.errors.required">Credit Card Number is required.</div>
        </div>
      </div> -->
      <!-- <div class="row">
      <div class="form-group col-sm-6 col-12">
        <label class="control-label oa-input-label">CVC</label>
        <input
          id="cvc-input"
          type="text"
          class="form-control"
          [(ngModel)]="card.cvc"
          [disabled]="disabled || stripeSource !== undefined"
          name="cvc"
          autocomplete="cc-csc"
          minlength="3"
          maxlength="4"
          size="4"
          inputmode="numeric"
          placeholder="Card Verification Code"
          #cvc="ngModel"
          required
          />
          <div *ngIf="cvc.invalid && (cvc.dirty || cvc.touched || captureError)" class="text-danger">
            <div *ngIf="cvc.errors.required">CVC is required.</div>
          </div>
        </div> -->
        <!-- <div class="form-group col-sm-6 col-12">
        <label class="control-label oa-input-label">Expiration</label> -->

        <!-- The StripeFormComponent.expirationDate is a proxy for card.exp.  -->
        <!-- <expiration-date-input [(expirationDate)]="expirationDate"></expiration-date-input> -->

        <!-- <input
        id="expiry-input"
        type="hidden"
        class="form-control"
        [(ngModel)]="card.exp"
        [disabled]="disabled"
        name="exp"
        autocomplete="cc-exp"
        minlength="1"
        maxlength="5"
        size="5"
        inputmode="numeric"
        placeholder="MM / YY"
        #exp="ngModel"
        required
        />

        <div *ngIf="exp.invalid && (exp.dirty || exp.touched || captureError)" class="text-danger">
          <div *ngIf="exp.errors.required">Expiration is required.</div>
        </div>
      </div> -->
    <!-- </div> -->

    <!-- <div id="payment-element"></div>

    <div id="error-message"> -->
      <!-- Display error message to your customers here -->

      <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
        <ngx-stripe-card [options]="cardOptions" (change)="onChange($event)"/>
      </ngx-stripe-elements>
      <br />
    <!-- </div> -->
  </div>
  <div class="terms">
    <table>
      <tr>
        <td style="padding-right: 10px">
          <i class="fa fa-lock fa-2x" aria-hidden="true"></i>
        </td>
        <td>
          Your credit card number will not be stored by Outdoor Access, but by our secure merchant processor
          <a href="https://stripe.com" target="_blank">Stripe, Inc</a>.
        </td>
      </tr>
    </table>
  </div>
  <ng-content select="[aria-valuetext=details]"></ng-content>
</form>
